module.exports = __webpack_public_path__ + "img/Img9.f18ac13c.jpg";